// components/folders/new-folder-modal.tsx
"use client";

import { ResponsiveModal } from "@/components/responsive-modal";
import { useI18n } from "@/locales/client";
import useNewFolderModal from "../hooks/use-new-folder-modal";
import FolderForm from "./folder-form";

export const NewFolderModal = () => {
  const t = useI18n();
  const { isOpen, onClose } = useNewFolderModal();

  return (
    <ResponsiveModal
      open={isOpen}
      onOpenChange={onClose}
      title={t("createNewFolder")}
      description={t("createNewFolderDescription")}
      form={<FolderForm mode="create" isOpen={isOpen} setIsOpen={onClose} />}
    />
  );
};
